// src/components/tasks/TasksQuickActionsCard.tsx
// Quick action buttons card
import React from 'react';
import { IonIcon } from '@ionic/react';
import { add, listOutline, repeatOutline, settingsOutline } from 'ionicons/icons';
import { Card } from '../ui/Card';
import './tasks.css';

export interface TasksQuickActionsCardProps {
  onAssignTask: () => void;
  onNewList: () => void;
  onNewRoutine: () => void;
  onManage: () => void;
}

export const TasksQuickActionsCard: React.FC<TasksQuickActionsCardProps> = ({
  onAssignTask,
  onNewList,
  onNewRoutine,
  onManage,
}) => {
  return (
    <Card title="Quick Actions" size="md">
      <div className="tasks-quick-actions">
        <button className="tasks-quick-action-btn" onClick={onAssignTask}>
          <IonIcon icon={add} />
          Assign Task
        </button>

        <button className="tasks-quick-action-btn" onClick={onNewList}>
          <IonIcon icon={listOutline} />
          New List
        </button>

        <button className="tasks-quick-action-btn" onClick={onNewRoutine}>
          <IonIcon icon={repeatOutline} />
          New Routine
        </button>

        <button className="tasks-quick-action-btn" onClick={onManage}>
          <IonIcon icon={settingsOutline} />
          Manage
        </button>
      </div>
    </Card>
  );
};

TasksQuickActionsCard.displayName = 'TasksQuickActionsCard';

export default TasksQuickActionsCard;
